import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material'
import { useState, useEffect, useRef, FunctionComponent } from 'react'
import FileUploadService from '../../../../../../shared/services/file-upload/file-upload.service'

export const SheetConfigurationStep: FunctionComponent<{
  fileData: any[]
  onSheetNumberChange: (sheetNumber: number) => void
  onHeaderRowChange: (headerRow: number) => void
}> = ({
  fileData,
  onSheetNumberChange,
  onHeaderRowChange
}) => {
    //Services
    const fileUploadServiceRef = useRef(new FileUploadService())
    //State
    const [sheetNumber, setSheetNumber] = useState<number>(1)
    const [headerRow, setHeaderRow] = useState<number>(1)
    const [sheets, setSheets] = useState<{ sheetNumber: number, sheetName: string }[]>([])
    //Loading State
    const [isLoadingSheets, setIsLoadingSheets] = useState(false)

    useEffect(() => {
      //Only necessary for excel, as CSV doesnt have multiple sheets
      if (fileData.length > 0 && fileData[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        setIsLoadingSheets(true)
        const form = new FormData()
        form.append('files', fileData[0])
        fileUploadServiceRef.current.getNumberOfSheetsInExcelFile(form)
          .then(response => {
            setSheets(response.sheets)
            setIsLoadingSheets(false)
          })
          .catch(err => {
            setIsLoadingSheets(false)
          })
      }
    }, [fileData])

    const handleSheetNumberChange = (event: SelectChangeEvent<number>) => {
      const value = Number(event.target.value)
      setSheetNumber(value)
      onSheetNumberChange(value)
    }

    const handleHeaderRowChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = Number(event.target.value)
      setHeaderRow(value)
      onHeaderRowChange(value)
    }

    return (
      <Box sx={{ py: 1 }}>
        <Typography variant="h6" sx={{ mb: 2, textAlign: 'left' }}>
          Configure File Settings
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', textAlign: 'left' }}>
          Specify which sheet and header row to use for your data.
        </Typography>
        <Box sx={{ maxWidth: 500 }}>
          {sheets.length > 1 && (
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>Sheet Number</InputLabel>
              <Select
                value={sheetNumber}
                onChange={handleSheetNumberChange}
                label="Sheet Number"
                disabled={isLoadingSheets}
              >
                {sheets.map((sheet) => (
                  <MenuItem key={sheet.sheetNumber} value={sheet.sheetNumber}>
                    {sheet.sheetName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <TextField
            fullWidth
            variant='outlined'
            id='headerRow'
            name='headerRow'
            label='Row Number of Headings'
            type='number'
            inputProps={{ min: 1 }}
            value={headerRow}
            onChange={handleHeaderRowChange}
            sx={{ mb: 3 }}
          />
        </Box>
      </Box>
    )
  }
